import { Component, ElementRef, Inject, Signal, signal, ViewChild, WritableSignal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { FormControl } from '@angular/forms';
import { Observable, Subject, debounceTime, filter, map, startWith, switchMap } from 'rxjs';
import { Group } from '../../../models/group';
import { User } from '../../../models/user';
import { UsersService } from '../../../services/user.service';
import { BulkUserChooserComponent } from '../../bulk-user-chooser/bulk-user-chooser.component';
import { GroupMembersService } from '../../../services/group-members.service';
import { Project } from '../../../models/project';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ADGroup } from '../../../models/ad-group';

@Component({
  selector: 'app-group-membership-editor',
  standalone: true,
  templateUrl: './group-membership-editor.component.html',
  styleUrls: ['./group-membership-editor.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatTableModule,
    MatIconModule,
    MatChipsModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatSelectModule,
    BulkUserChooserComponent,
    DragDropModule
],
})
export class GroupMembershipEditorComponent {
  @ViewChild('userFilterInput', {static: false}) input!: ElementRef<HTMLInputElement>;
  title: string = "Add members to group ";
  group!: WritableSignal<Group>;

  tagControl = new FormControl('');
  userFilter = new FormControl('');
  membershipType = new FormControl('');
  filteredTags$: Observable<string[]>;
  userDataSource = new MatTableDataSource<User>([]);
  selectedUsers: User[] = [];
  chosenUsers: User[] = [];
  allTags: string[] = ['Admin', 'Finance', 'HR', 'IT', 'Root']; // Example tag list
  displayedColumns: string[] = ['name', 'association', 'tools'];
  _options = new Subject<User[]>();
  options = this._options.asObservable();
  _filter = new Subject<string>();
  filter = this._filter.asObservable();
  constructor(
    public dialogRef: MatDialogRef<GroupMembershipEditorComponent>,
    private userService: UsersService, private groupMembersService: GroupMembersService,
    @Inject(MAT_DIALOG_DATA) public data: { title: string }
  ) {
    // this.group = signal(data.group);
    this.title = this.data.title ?? "Add users...";
    this.filteredTags$ = this.tagControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filterTags(value || ''))
    );
    this.filter.pipe(
      filter(c => c != null),
      debounceTime(100),
      switchMap(c => this.userService.filterUsers([ { chip: null, value: c.trim() }], 5))
    ).subscribe(resp => this._options.next(resp.users));
  }

  private _filterTags(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter((tag) =>
      tag.toLowerCase().includes(filterValue)
    );
  }
  
  filterUsers() {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    this._filter.next(filterValue);
  }

  usersChange(users: User[]) {
    this.chosenUsers = users;
    console.log(arguments, this.userFilter.value);
  }

  cancel() {
    this.dialogRef.close();
  }

  formatUserFn(user: User) {
    return user ? user.hawkId : '';
  }

  addMembers() {
    console.log(this.chosenUsers);
    this.dialogRef.close(this.chosenUsers);
  }
}
